import {
  BusyButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogDeleteIcon,
  Flex,
  Icon,
  PaletteVariants,
  Text,
} from '@lucidhq/lucidium';
import { FC, ReactNode, SVGProps } from 'react';

export interface ConfirmationDialogProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  contentText: string | ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  isLoading?: boolean;
  dialogIcon?: FC<SVGProps<SVGSVGElement>>;
  confirmButtonPalette?: PaletteVariants;
}

export const ConfirmationDialog = ({
  onClose,
  onConfirm,
  isOpen,
  contentText,
  confirmLabel,
  isLoading,
  cancelLabel = 'Cancel',
  dialogIcon: DialogIcon = DialogDeleteIcon,
  confirmButtonPalette = 'danger',
}: ConfirmationDialogProps) => (
  <Dialog isOpen={isOpen} onClose={onClose} lss={{ minWidth: 'xs' }}>
    <DialogContent
      lss={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Flex
        lss={{
          mb: 10,
          bg: 'gray200',
          width: '65px',
          height: '65px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 'rounded',
        }}
      >
        <Icon as={DialogIcon} size={40} />
      </Flex>
      <Text lss={{ width: '270px', textAlign: 'center' }}>{contentText}</Text>
    </DialogContent>
    <DialogActions>
      <BusyButton
        scale="sm"
        palette={confirmButtonPalette}
        data-testid="confirm-button"
        onClick={onConfirm}
        disabled={isLoading}
        isBusy={isLoading}
      >
        {confirmLabel}
      </BusyButton>
      <Button
        scale="sm"
        palette="primary"
        emphasis="medium"
        onClick={onClose}
        lss={{ mx: 'sm' }}
      >
        {cancelLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
